import type { ReactNode } from "react";

import { useAuthMe } from "@/hooks/useAuthMe";

/**
 * Mount inside the shell layout after the root session gate. Subscribes to the
 * shared `useAuthMe` cache so child routes do not trigger duplicate `/api/auth/me` calls.
 */
export function Authed({ children }: { children: ReactNode }) {
  useAuthMe();
  return <>{children}</>;
}
